module.exports = __webpack_public_path__ + "img/background-pg-xl-white.25c060f1.png";